module.exports = __webpack_public_path__ + "d382480aea27a70a2a79160ffaf171d5.png";